import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 14,
	viewBox: "0 0 12 14",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11.3934 8.08363L1.84941 13.8259C1.03945 14.3128 0 13.7233 0 12.7419V1.25725C0 0.277391 1.03795 -0.313637 1.84941 0.174739L11.3934 5.91705C11.5777 6.02611 11.7308 6.18376 11.8374 6.37402C11.9439 6.56427 12 6.78034 12 7.00034C12 7.22033 11.9439 7.43641 11.8374 7.62666C11.7308 7.81691 11.5777 7.97456 11.3934 8.08363Z" })
});
export default SvgPlay;
